import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class EquipmentsAnalytics extends BaseAnalytics {
    constructor(category: string) {
        super();
        this.category = category;
    }

    clickContinue() {
        this.send('click_continue');
    }

    chooseEquipmentContinue() {
        this.send('choose_equipment_continue');
    }

    addProduct(title: string) {
        this.send('add_product', title);
    }

    deleteEquipment(title: string) {
        this.send('delete_equipment', title);
    }

    clickShowMore() {
        this.send('click_show_more_equipment');
    }

    chooseCostType(title: string) {
        this.send('choose_cost_type', title);
    }

    chooseDuration(title: string) {
        this.send('choose_duration', title);
    }

    clickAddProduct(title: string) {
        this.send('click_add_product', title);
    }
}

export default EquipmentsAnalytics;
